import VACANCIES from './vacancies.services';
import EVENTS from './events.services';
import REPORTS from './reports.services';
import EMPLOYERS from './employers.services';

const SERVICES = {
	VACANCIES,
	EVENTS,
	REPORTS,
	EMPLOYERS
};

export default SERVICES;
